<template>
  <v-layout >
    <v-card flat class="conteneurLead" id="conteneurLead" style="width: 100%;">
      <v-card-title class="primary white--text">
        <v-btn icon @click="cancelDialogEdit()"><v-icon class="white--text">close</v-icon></v-btn>
        <div class="title tf_title_dialog">{{ $t('edit') | cap }} : {{faqDialog.name}}</div>
        <v-spacer></v-spacer>
        <v-btn v-if="$vuetify.breakpoint.smAndDown" flat @click="confirmeDialogEdit()" class="white--text">{{ $t('submit') }}</v-btn>
      </v-card-title>
      <v-tabs
        v-model="currentTab"
        left
        slider-color="secondary"
      >
        <v-tab
          v-for="tab of tabs"
          :key="tab.index"
        >
          <v-icon class="primary--text">{{tab.icone}}</v-icon>
          {{!$vuetify.breakpoint.smAndDown ? tab.name :  tab.subName}}
        </v-tab>
        <v-tab-item :key="'tab_fiche'" style="overflow: auto;">
          <!-- Chargement -->
          <div v-if="loading" class="text-xs-center">
            <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
          </div>
          <v-card-text v-else :style="!$vuetify.breakpoint.smAndDown ? 'height: calc(100vh - 300px);' : ''">
              <v-layout row wrap>
                <!-- infos intention -->
                <v-flex xs12 md4>
                  <v-card-text>
                    <p v-if="modeExpert">
                      <span class='body-1 font-italic'>id :</span><br>
                      <span class='body-2 font-weight-bold'>{{faqDialog.id}}</span>
                    </p>
                    <p v-if="modeExpert">
                      <span class='body-1 font-italic'>nom de l'intention :</span><br>
                      <span class='body-2 font-weight-bold'>{{faqDialog.intend}}</span>
                    </p>
                    <p v-if="modeExpert">
                      <span class='body-1 font-italic'>Parents :</span><br>
                      <span class='body-2 font-weight-bold'>{{faqDialog.parent}}</span>
                    </p>
                    <p v-if="modeExpert">
                      <span class='body-1 font-italic'>type :</span><br>
                      <span class='body-2 font-weight-bold'>{{faqDialog.type}}</span>
                    </p>
                    <p>
                      <v-textarea 
                        box
                        row=1
                        :label="$t('sujet')" 
                        v-model="faqDialog.name"
                        max="255"
                        hint="Obligatoire"
                      ></v-textarea>
                    </p>
                    <p>
                      <v-textarea 
                        :label="$t('description')" 
                        v-model="faqDialog.desc"
                        counter
                        maxlength="128"
                        hint="Obligatoire"
                      ></v-textarea>
                    </p>
                    <p v-if="modeExpert">
                      --debug--<br>
                      {{checkModifText}}<br>
                      {{faqDialog}}
                    </p>
                  </v-card-text>
                </v-flex>
                <v-spacer></v-spacer>
                <!-- Choix/création de l'intention -->
                <v-flex xs12 md8>
                  <v-container>
                    <v-timeline
                      dense
                      align-top
                    >
                    <!-- question internaute de type text -->
                      <v-timeline-item
                        large
                        right
                        color="#A3CDEE"
                      >
                        <template v-slot:icon >
                          <v-icon color="white">person</v-icon>
                        </template>
                        <template v-slot:opposite>
                        </template>
                        <v-layout justify-space-between>
                          <v-flex xs7 class="caption font-italic">{{$t('exempleMessageInternaute')}}</v-flex>
                        </v-layout>
                        <v-card class="elevation-4" color="#f0f8ff">
                          <v-card-text class="body-2 font-weight-medium">
                            {{randomQuestion}}
                          </v-card-text>
                        </v-card>
                      </v-timeline-item>
                    <!-- reponse bot de type text -->
                      <v-timeline-item
                        v-if="faqDialog.output1.type == 'text'"
                        large
                        right
                        color="#1F89C6"
                      >
                        <template v-slot:icon>
                          <v-icon color="white">smart_toy</v-icon>
                        </template>

                        <template v-slot:opposite>
                          <span>{{faqDialog.output1.type}}</span>
                        </template>
                        <v-layout justify-space-between>
                          <v-flex xs7 class="caption font-italic">{{$t('reponseBot')}}</v-flex>
                        </v-layout>
                        <v-card 
                          class="elevation-4"
                          color="#8fcbed"
                        >
                          <v-slide-y-transition>
                            <v-layout justify-space-between >
                              <v-flex xs11>
                                <div 
                                  v-if="!modifRep1 && faqDialog.output1.text.length > maxlengthOption"
                                  class="alertOption"
                                >
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                      <v-btn
                                        color="red"
                                        flat
                                        large
                                        icon
                                        @click="modifReps(1)"
                                        v-on="on"
                                      >
                                        <v-icon>error</v-icon>
                                      </v-btn>
                                    </template>
                                  <span>Le contenue dépasse le nombre maximum de caractères</span>
                                  </v-tooltip>
                                </div>
                                <v-card-text
                                  v-if="!modifRep1"
                                  class="body-2 font-weight-medium"
                                  v-html="faqDialog.output1.text"
                                >
                                </v-card-text>
                                <v-card-text
                                  v-else-if="modifRep1"
                                  class="body-2 font-weight-medium"
                                >
                                  <wz-txt-editor
                                    :contentTxt="faqDialog.output1.text"
                                    contentId="output1"
                                    :lang="$store.state._User.lang"
                                    :maxChar="maxlengthOption"
                                    @changeContent="onChangeText1"
                                  >
                                  </wz-txt-editor>
                                </v-card-text>
                              </v-flex>
                              <v-flex xs1 text-xs-right class="margRight">
                                <v-btn v-if="!modifRep1" color="primary" outline  fab small @click="modifReps(1)">
                                  <v-icon>edit</v-icon>
                                </v-btn>
                                <v-btn v-else color="primary" outline fab small @click="modifRep1 = false">
                                  <v-icon>edit_off</v-icon>
                                </v-btn>
                              </v-flex>
                            </v-layout>
                          </v-slide-y-transition>
                        </v-card>
                      </v-timeline-item>

                    <!-- reponse bot de type text -->
                      <v-timeline-item
                        v-if="faqDialog.output2.type == 'text'"
                        large
                        right
                        color="#1F89C6"
                      >
                        <template v-slot:icon>
                          <v-icon color="white">smart_toy</v-icon>
                        </template>

                        <template v-slot:opposite>
                          <span>{{faqDialog.output2.type}}</span>
                        </template>
                        <v-layout justify-space-between>
                          <v-flex xs7 class="caption font-italic">{{$t('compReponseBot')}}</v-flex>
                        </v-layout>
                        <v-card 
                          class="elevation-4"
                          color="#8fcbed"
                        >
                          <v-slide-y-transition>
                            <v-layout justify-space-between>
                              <v-flex xs11>
                                <div 
                                  v-if="!modifRep2 && faqDialog.output2.text.length > maxlengthOption"
                                  class="alertOption"
                                >
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                      <v-btn
                                        color="red"
                                        flat
                                        large
                                        icon
                                        @click="modifReps(2)"
                                        v-on="on"
                                      >
                                        <v-icon>error</v-icon>
                                      </v-btn>
                                    </template>
                                  <span>Le contenue dépasse le nombre maximum de caractères</span>
                                  </v-tooltip>
                                </div>

                                <v-card-text
                                  v-if="!modifRep2"
                                  class="body-2 font-weight-medium"
                                  v-html="faqDialog.output2.text"
                                >
                                </v-card-text>

                                <v-card-text
                                  v-else-if="modifRep2"
                                  class="body-2 font-weight-medium"
                                >
                                  <wz-txt-editor
                                    :contentTxt="faqDialog.output2.text"
                                    contentId="output2"
                                    :lang="$store.state._User.lang"
                                    :maxChar="maxlengthOption"
                                    @changeContent="onChangeText2"
                                  >
                                  </wz-txt-editor>
                                </v-card-text>
                              </v-flex>

                              <v-flex xs1 text-xs-right class="margRight">
                                <v-btn v-if="!modifRep2" color="primary" outline  fab small @click="modifReps(2)">
                                  <v-icon>edit</v-icon>
                                </v-btn>
                                <v-btn v-else color="primary" outline fab small @click="modifRep2 = false">
                                  <v-icon>edit_off</v-icon>
                                </v-btn>
                              </v-flex>

                            </v-layout>
                          </v-slide-y-transition>
                        </v-card>
                      </v-timeline-item>

                    <!-- reponse bot de type option (avec boutons )-->
                      <v-timeline-item
                        v-if="faqDialog.output1.type == 'option'"
                        large
                        right
                        color="#1F89C6"
                      >
                        <template v-slot:icon>
                          <v-icon color="white">smart_toy</v-icon>
                        </template>

                        <template v-slot:opposite>
                          <span>{{faqDialog.output1.type}}</span>
                        </template>
                        <v-layout justify-space-between>
                          <v-flex xs7 class="caption font-italic">{{$t('reponseBot')}}</v-flex>
                        </v-layout>
                        <v-card 
                          class="elevation-4"
                          color="#8fcbed"
                        >
                          <v-slide-y-transition>
                            <v-layout justify-space-between>
                              <v-flex xs11>
                                <v-card-text
                                  v-if="!modifRep1"
                                  class="body-2 font-weight-medium"
                                  v-html="faqDialog.output1.title"
                                >
                                </v-card-text>
                                <div class="text-xs-right">
                                  <v-btn
                                    v-for="(option, index) in faqDialog.output1.options"
                                    :key="index"
                                    round
                                    color="primary"
                                    dark
                                  >{{option.label}}</v-btn>
                                </div>
  
                                <!--
                                <v-card-text v-else class="body-2 font-weight-medium">
                                  <vue-editor v-model="faqDialog.output1.title" @text-change="onChangeText1" :editorToolbar="customToolbar"></vue-editor>
                                </v-card-text>
                                -->
                              </v-flex>
                              <!--
                              <v-flex xs1 text-xs-right>
                                <v-btn v-if="!modifRep1" flat small icon color="light-green lighten-1" @click="modifRep1 = true">
                                  <v-icon>edit</v-icon>
                                </v-btn>
                                <v-btn v-else flat small icon color="light-green lighten-1" @click="modifReps(1)">
                                  <v-icon>edit_off</v-icon>
                                </v-btn>
                              </v-flex>
                              -->
                            </v-layout>
                          </v-slide-y-transition>

                        </v-card>
                      </v-timeline-item>

                    <!-- add reponse -->
                      <v-timeline-item
                        v-if="checkReponse"
                        large
                        right
                        color="#1F89C6"
                      >
                        <template v-slot:icon>
                          <v-icon color="white">add</v-icon>
                        </template>
                        <v-btn
                          class="mx-0"
                          color="white"
                          @click="addReponse"
                        >
                          <span v-if="faqDialog.output1.text">Apporter un complément de réponse</span>
                          <span v-else>Ajouter une réponse</span>
                        </v-btn>
                        
                      </v-timeline-item>
                    <!-- escalades -->
                      <v-timeline-item
                        large
                        right
                        color="#ff7f00"
                      >
                        <template v-slot:icon>
                          <v-icon color="white">live_help</v-icon>
                        </template>
                        <div v-if="editNewJumpTo || faqDialog.nextstep!==''">
                          <v-layout justify-space-between>
                            <v-flex xs11>
                              <v-card class="elevation-6">
                                <v-select
                                  :items="jumps"
                                  label="Choisir une escalade"
                                  v-model="faqDialog.nextstep"
                                  outline
                                  v-on:change="changeJumpTo"
                                ></v-select>
                              </v-card>
                            </v-flex>
                            <v-flex xs1 text-xs-right>
                              <v-btn v-if="faqDialog.nextstep==''" color="primary" fab small dark @click="editNewJumpTo=false">
                                <v-icon>close</v-icon>
                              </v-btn>
                              <v-btn v-else color="primary" fab small dark @click="deleteJumpTo">
                                <v-icon>delete</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </div>
                        <div v-else>
                          <v-btn
                            class="mx-0"
                            color="rgb(255 127 0)"
                            outline
                            @click="editNewJumpTo=true"
                          >
                            Rediriger vers une question de satisfaction
                            <v-icon right dark class="iconeOption">turn_right</v-icon>
                          </v-btn>
                        </div>
                      </v-timeline-item>
                    </v-timeline>
                  </v-container>
                </v-flex>
              </v-layout>
          </v-card-text>
        </v-tab-item>

        <!-- tab liste questions possibles -->
        <v-tab-item :key="'tab_question'"  style="overflow: auto;">
          <!-- Chargement -->
          <div v-if="loading" class="text-xs-center">
            <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
          </div>
          <v-card-text v-else :style="!$vuetify.breakpoint.smAndDown ? 'height: calc(100vh - 300px);' : ''">
              <v-layout row wrap>
                <!-- infos question -->
                <v-flex xs12 md4>
                  <v-card-text>
                  </v-card-text>
                </v-flex>
                <v-spacer></v-spacer>
                <!-- liste des questions -->
                <v-flex xs12 md8>
                  <v-container>
                    <span class="caption font-italic">Exemples de message de l'internaute</span>
                    <v-timeline
                      dense
                      align-top
                    >
                    
                      <v-timeline-item
                        v-for="(question, index) in listeQuestion"
                        :key="index"
                        large
                        right
                        color="#A3CDEE"
                      >

                        <template v-slot:icon >
                          <v-icon color="white">person</v-icon>
                        </template>

                        <template v-slot:opposite>
                        </template>
                        <v-layout justify-space-between>
                          <v-flex xs7 class="caption font-italic"></v-flex>
                        </v-layout>
                        <v-card class="elevation-4" color="#f0f8ff" >
                          <v-card-text
                            class="body-2 font-weight-medium"
                            
                          >
                            <v-flex mr-5 v-on:click="modifExample(question)">{{question}}</v-flex>
                            <div class="tf_modifExemple">
                              <v-btn icon flat @click.stop="modifExample(question)">
                                <v-icon>edit</v-icon>
                              </v-btn> 
                            </div>
                            <div class="tf_removeExemple">
                              <v-btn icon flat @click.stop="openDialogDeleteExemple(index)">
                                <v-icon>delete</v-icon>
                              </v-btn> 
                            </div>

                          </v-card-text>
                        </v-card>
                      </v-timeline-item>
                    </v-timeline>

                    <!-- add exemple -->
                    <v-flex xs6 class="text-xs-right">
                      <div  class='btnIntentBot' @click="addExample()">
                          <v-btn small icon color="secondary" >
                          <v-icon>add</v-icon>
                          </v-btn>
                          <span class="pl-2">Ajouter un nouvel exemple</span>
                      </div>
                    </v-flex>
                    
                  </v-container>
                </v-flex>

              </v-layout>

          </v-card-text>
        </v-tab-item>
      </v-tabs>

      <v-card-actions v-if="!$vuetify.breakpoint.smAndDown && currentTab == 0">
        <v-spacer></v-spacer>
        <v-btn flat @click="cancelDialogEdit()">{{ $t('cancel') }}</v-btn>
        <v-btn flat @click="dialogDelete()">Supprimer la connaissance</v-btn>
        <v-btn color="primary" @click="confirmeDialogEdit()" :disabled="!checkModifText && !checkModifSelect">{{ $t('submit') }}</v-btn>
      </v-card-actions>
    </v-card>

    <!-- Création INTENT (avec un seul exemple) -->
    <v-dialog
      v-model="showDialogCreateIntent"
      persistent
      max-width="390"
    >
    <!--
      <wz-new-intent
        :newIntentDialog="newIntentDialog"
        :intents="intents"
        :activeIntents="activeIntents"
        :modeExpert="modeExpert"
        @closeDialog="closeDialogCreatIntent"
      ></wz-new-intent>
      -->
    </v-dialog> 

    <!-- Dialog confirmation -->
    <v-dialog
      v-model="showDialogConfirmation"
      scrollable
      max-width="390"
    >
      <wz-dialog-confirm
        :titleDialogConfirm="titleDialogConfirm"
        :contentDialogConfirm="contentDialogConfirm"
        :showDialogConfirmation="showDialogConfirmation"
        :closeDialogUniquement="closeDialogUniquement"
        :loadingModifFAQ="loadingModifFAQ"
        :modifBaseCo="modifBaseCo"
        @closeDialogConfirm="closeDialogConfirm"
        @justCloseDialogConfirm="justCloseDialogConfirm"
        @submitDialogConfirm="submitDialogConfirm"
      ></wz-dialog-confirm>
    </v-dialog> 

    <!-- Delete confirmation -->
    <v-dialog
      v-model="showDialogDelete"
      scrollable
      max-width="490"
    >
      <wz-dialog-confirm
        :titleDialogConfirm="$t('supFAQ1a')"
        :contentDialogConfirm="$t('supFAQ2')"
        :showDialogConfirmation="false"
        :loadingModifFAQ="loadingModifFAQ"
        @closeDialogConfirm="showDialogDelete = false"
        @justCloseDialogConfirm="justCloseDialogConfirm"
        @submitDialogConfirm="submitDeleteConfirm"
      ></wz-dialog-confirm>
    </v-dialog> 

    <!-- Ajoute un exemple de question à l'INTENT -->
    <v-dialog
      v-model="showDialogAddQuestionIntent"
      persistent
      max-width="390"
    >
      <wz-new-question-intent
        :intentDialog="intentDialog"
        :modeExpert="modeExpert"
        :botWorkspace="botWorkspace"
        :loadingDialog="loadingDialogNew"
        @closeDialog="closeDialogNewQuestionIntent"
        @addNewEx="addNewEx"
      ></wz-new-question-intent>
    </v-dialog>  
    <!-- Supprime un exemple de question à l'INTENT -->
    <v-dialog
      v-model="showDialogSupExempleIntent"
      persistent
      max-width="390"
    >
      <wz-delete-exemple-intent
        :exemple="exempleSup"
        :faqDialog="faqDialog"
        :listeExemples="listeQuestion"
        :modeExpert="modeExpert"
        :botWorkspace="botWorkspace"
        @closeDialog="closeDialogSupExempleIntent"
        @removeExemple="majExempleListe"
      ></wz-delete-exemple-intent>
    </v-dialog> 
    <!-- MOdification du message -->
    <v-dialog
      v-model="showDialogEditExempleIntent"
      persistent
      max-width="390"
    >
      <v-card flat class="conteneurLead" id="conteneurLead">
        <v-card-title class="primary white--text"  style="height: 52px;  padding: 0px;">
          <v-btn icon @click="cancelDialogModifExemple()"><v-icon class="white--text">close</v-icon></v-btn>
          <div
            class="title tf_title_dialog"
          >
            {{ $t('edition') | cap }}
          </div>
          <v-spacer></v-spacer>
          <v-btn
              :loading="loadingModifExemple"
              :disabled="loadingModifExemple"
              v-if="$vuetify.breakpoint.smAndDown"
              flat
              @click.native="submitExempleIntent"
              class="white--text"
          >{{ $t('edit') }}</v-btn>
        </v-card-title>
        <v-card-text>
          <p v-if="modeExpert">
            <span class='body-1 font-italic'>{{$t('intentCode')}} :</span><br>
            <span class='body-2 font-weight-bold'>{{intentDialog.code}}</span>
          </p>
          <p v-if="modeExpert">
            <span class='body-1 font-italic'>{{$t('Description')}} :</span><br>
            <span class='body-2 font-weight-bold'>{{intentDialog.desc}}</span>
          </p>
          <v-textarea 
            :label="$t('sentence') + '*'" 
            v-model="exempleSelected"
            counter
            maxlength="128"
            required
            hint="Exemple obligatoire"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="cancelDialogModifExemple()">{{ $t('cancel') }}</v-btn>
          <v-btn
            :loading="loadingModifExemple"
            :disabled="loadingModifExemple"
            color="primary"
            flat
            @click.native="submitExempleIntent"
          >{{ $t('edit') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> 

    <!-- popup avertissement text trop long -->
    <v-dialog
      v-model="showPopUpLongText"
      max-width="400px"
    >
      <v-card>
        <v-card-title>
          <v-toolbar
            color="primary"
            card
            dark
            scroll-target="#scrolling-content"
          >
            <v-toolbar-title>
              <span class="headline">Attention !</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="showPopUpLongText = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>

        <v-card-text>
          <p>Un texte que vous voulez enregistrer est trop long.<br>Veuillez reduire le nombre de caractères avant de le sauvegarder</p>
          <p>
            Les textes trop long sont indiqués pas cette icone : <v-icon dark color="red">error</v-icon>
          </p>
          <p>
            Vous pouvez afficher le code HTML du text trop long en cliquant sur cette icone  : <v-icon dark color="grey">code</v-icon>
          </p>
        </v-card-text>
        <v-divider class="mt-5"></v-divider>
        <v-card-actions>
          <v-btn  flat color="primary" type="submit" @click="showPopUpLongText = false;">Fermer</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-layout>
</template>


<script>
import _ from 'lodash'
export default {
  props: {
    showDialogUpdate: {
      type: Boolean,
      default: false
    },
    faqDialog: {
      type: Object,
      default: () => ({})
    },
    modeExpert: {
      type: Boolean,
      default: false
    },
    botWorkspace: {
      type: String,
      default: ''
    },
    jumps: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      editNewJumpTo: false,
      loadingModifFAQ: false,
      showDialogAddQuestionIntent: false,
      showDialogSupExempleIntent: false,
      showDialogEditExempleIntent: false,
      loadingDialogNew: false,
      exempleSup: '',
      exempleSelected: '',
      oldExempleSelected: '',
      loading: false,
      loadingModifExemple: false,
      resAjx: null,
      tabs: [],
      listIntents: [],
      currentTab: 0,
      originalIntent: '',
      intentToCreate: '',
      actualIntent: '-',
      blockSelector: false,
      changeIntent: '',
      // dialog création new intention
      newIntentDialog: {code: 'tf_' + Date.now(), desc: '', ex: 'toto'},
      showDialogCreateIntent: false,
      intents: [],
      activeIntents: 0,
      randomQuestion: '',
      modifRep1: false,
      modifRep2: false,
      listeQuestion: [],
      showDialogConfirmation: false,
      showDialogDelete: false,
      titleDialogConfirm: '',
      contentDialogConfirm: '',
      ModifFaqDialog: {type: '', output1: '', output2: '', name: '', desc: '', nextstep: ''},
      modifications: true,
      intentDialog: {},
      maxlengthOption: 512,
      showPopUpLongText: false,
      closeDialogUniquement: false,
      modifBaseCo: false,
      checkModifSelect: false
    }
  },

  computed: {
    checkReponse () {
      // pour le moment on ne peut pas modifier les options
      if (this.faqDialog.output1.type === 'option') {
        return false
      // pour le reste c'est ok pour les modifs
      } else {
        if (
          (!this.faqDialog.output2.type || this.faqDialog.output2.type !== 'text') ||
          !this.faqDialog.output1.type && (!this.faqDialog.output2.type || this.faqDialog.output2.type !== 'text')
          ) {
          return true
        }
      }
    },
    checkModifText () {
      let testOutput1 = _.startsWith(this.faqDialog.output1.text, '<p>')
      let testCopyOutput1 = _.startsWith(this.ModifFaqDialog.output1.text, '<p>')
      if (testOutput1) { // si il y a des balises <p>
        if (!testCopyOutput1) { // si pas sur la copy du text, il faut les ajouter
          this.ModifFaqDialog.output1.text = '<p>' + this.ModifFaqDialog.output1.text + '</p>'
        }
      }
      let testOutput2 = _.startsWith(this.faqDialog.output2.text, '<p>')
      let testCopyOutput2 = _.startsWith(this.ModifFaqDialog.output2.text, '<p>')
      if (testOutput2) { // si il y a des balises <p>
        if (!testCopyOutput2) { // si pas sur la copy du text, il faut les ajouter
          this.ModifFaqDialog.output2.text = '<p>' + this.ModifFaqDialog.output2.text + '</p>'
        }
      }
      // let testName = this.faqDialog.name
      // let testCopyName = this.ModifFaqDialog.name
      // if (this.faqDialog.output1.text.search(regex)) {}
      // this.faqDialog.output1.text.replace(regex, '')
      if (
        this.ModifFaqDialog.output1.text === this.faqDialog.output1.text &&
        this.ModifFaqDialog.output2.text === this.faqDialog.output2.text &&
        // this.faqDialog.output1.text === '' &&
        this.ModifFaqDialog.name === this.faqDialog.name &&
        this.ModifFaqDialog.desc === this.faqDialog.desc
        ) {
        return false
      } else {
        return true
      }
    }
  },

  mounted () {
    this.tabs = [
      { index: 0, name: this.$t('reponseBot'), subName: this.$t('Réponse bot'), icone: 'assignment' },
      { index: 1, name: this.$t('listAllMessage'), subName: this.$t('Messages'), icone: 'question_answer' }
    ]
  },
  created () {
  },
  methods: {
    cancelDialogEdit () {
      // check si il y a eu des modifs dans le text
      if (this.ModifFaqDialog.output1.text === this.faqDialog.output1.text && this.ModifFaqDialog.output2.text === this.faqDialog.output2.text) {
        this.$emit('closeDialog') // on peut fermer cette dialogBox sans alerter
        // fermer les editeurs de text
        this.modifRep1 = false
        this.modifRep2 = false
      } else {
        if (
        this.faqDialog.output1.text && this.faqDialog.output1.text.length > this.maxlengthOption ||
        this.faqDialog.output2.text && this.faqDialog.output2.text.length > this.maxlengthOption
        ) {
          this.showDialogConfirmation = true
          this.titleDialogConfirm = this.$t('warningTxt')
          this.contentDialogConfirm = this.$t('errorRepBot')
          this.modifBaseCo = true
          this.closeDialogUniquement = false
        } else {
          this.showDialogConfirmation = true
          this.titleDialogConfirm = this.$t('warningTxt')
          this.contentDialogConfirm = this.$t('modifTxtSauv')
          this.modifications = false
          this.modifBaseCo = false
          this.closeDialogUniquement = false
        }
      }
      // this.$emit('closeDialog')
    },
    dialogDelete () {
      this.showDialogDelete = true
    },
    clearIntentToCreate () {
      this.intentToCreate = ''
      this.blockSelector = false
    },
    initList () {
      console.log('initList', this.botWorkspace)
      // console.log('editor', editor)
      if (!this.botWorkspace || this.botWorkspace === 'undefined') {
        return
      }
      if (!this.$store.state._Sites.intents || this.$store.state._Sites.intents.length === 0) {
        this.loading = true
        this.resAjx = null
        this.listIntents = []

        let dataPost = new window.FormData()
        dataPost.append('botWorkspace', this.botWorkspace)
        this.axios.post('https://public.targetfirst.com/public/ibm/intents.php', dataPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        .then(response => {
          console.log('initList - response.data', response.data)
          this.resAjx = response.data
          this.$store.commit('_Sites/SET_INTENTS', this.resAjx)
        })
        .then(_ => {
          this.loading = false
          // console.log('initList - this.resAjx', this.resAjx)
          for (let n in this.resAjx) {
            let listExamples
            // si il y a une description on la prend sinon on la remplacepar le 1er exemple
            if (this.resAjx[n].desc !== '') {
              listExamples = this.resAjx[n].desc
            } else {
              listExamples = this.resAjx[n].ex[0]
            }
            this.listIntents.push({ listExamples,
              value: this.resAjx[n].code,
              code: this.resAjx[n].code,
              desc: this.resAjx[n].desc,
              ex: this.resAjx[n].ex,
              botWorkspace: this.botWorkspace
            })
          }
        })
        .catch()
      } else {
        // console.log('initList - this.$store.state._Sites.intents', this.$store.state._Sites.intents)
        this.loading = false
        this.listIntents = []
        var lesIntents = this.$store.state._Sites.intents
        for (let n in lesIntents) {
          let listExamples
          // si il y a une description on la prend sinon on la remplacepar le 1er exemple
          if (lesIntents[n].desc !== '') {
            listExamples = lesIntents[n].desc
          } else {
            listExamples = lesIntents[n].ex[0]
          }

          this.listIntents.push({ text: listExamples,
            value: lesIntents[n].code,
            code: lesIntents[n].code,
            desc: lesIntents[n].desc,
            ex: lesIntents[n].ex,
            botWorkspace: this.botWorkspace
          })
        }
        // console.log('this.listIntents', this.listIntents)
        // this.newIntentDialog.ex = this.intentDialog.code
        this.activeIntents = this.listIntents.length
      }
      // // clone le contenue afin de verifier si il y a des modif dans le text avant d'enregidtrer
      this.ModifFaqDialog = _.cloneDeep(this.faqDialog)
      // console.log('origin', this.ModifFaqDialog.output1.text)
      // console.log('modif', this.faqDialog.output1.text)
      // retourne une question au hasard
      this.questionsRandom(this.listIntents)
    },
    questionsRandom (listIntent) {
      console.log('questionsRandom', listIntent)
      if (listIntent.length) {
        let listeQuestions = []
        for (let i in listIntent) {
          // console.log('listIntent[i].code', listIntent[i].code)
          let intentionRecherche = this.faqDialog.intend.replace('#', '')
          // console.log('intentionRecherche', intentionRecherche)
          // il faut retire le # devant
          if (listIntent[i].code === intentionRecherche) {
            if (listIntent[i].ex.length) {
              for (let n in listIntent[i].ex) {
                listeQuestions.push(listIntent[i].ex[n])
              }
            }
          }
        }
        this.listeQuestion = listeQuestions
        // retourne une des question au hasard
        this.randomQuestion = listeQuestions[Math.floor(Math.random() * listeQuestions.length)]
      }
    },
    addReponse () {
      let newFaqDialog = _.cloneDeep(this.faqDialog)
      // si premiere réponse
      if ((!newFaqDialog.output1.type || newFaqDialog.output1.type !== 'text') &&
        (!newFaqDialog.output2.type || newFaqDialog.output2.type !== 'text')) {
        console.log('ajoute 1er reponse')
        newFaqDialog.output1.type = 'text'
        newFaqDialog.output1.title = ''
        newFaqDialog.output1.text = ''
        // this.modifRep1 = true
        this.modifReps(1)
      } else if (newFaqDialog.output1.type && (!newFaqDialog.output2.type || newFaqDialog.output2.type !== 'text')) {
        newFaqDialog.output2.type = 'text'
        newFaqDialog.output2.title = ''
        newFaqDialog.output2.text = ''
        console.log('ajoute 2eme reponse', newFaqDialog.output2)
        // this.modifRep2 = true
        this.modifReps(2)
      }
      // this.faqDialog = newFaqDialog
      // this.faqDialog = newFaqDialog
      this.$emit('addRep', newFaqDialog)
    },
    modifReps (num) {
      console.log('modifReps', num)
      if (num === 1) {
        this.modifRep1 = true
      } else if (num === 2) {
        this.modifRep2 = true
      }
    },
    onChangeText1 (value) {
      console.log('change text 1', value)
      this.faqDialog.output1.text = value
    },
    onChangeText2 (value) {
      console.log('change text 2', value)
      this.faqDialog.output2.text = value
    },
    confirmeDialogEdit () {
      console.log('confirmeDialogEdit modif', this.ModifFaqDialog.output1.text)
      console.log('confirmeDialogEdit origin', this.faqDialog.output1.text)
      this.showDialogConfirmation = true
      if (
        this.ModifFaqDialog.output1.text === this.faqDialog.output1.text &&
        this.ModifFaqDialog.output2.text === this.faqDialog.output2.text &&
        this.ModifFaqDialog.name === this.faqDialog.name &&
        this.ModifFaqDialog.desc === this.faqDialog.desc
        ) {
        this.titleDialogConfirm = 'Confirmation'
        this.contentDialogConfirm = 'Il n\'y a aucune modification sur les réponses du chatbot'
        this.modifications = true
        this.closeDialogUniquement = false
      } else if (
        this.faqDialog.output1.text && this.faqDialog.output1.text.length > this.maxlengthOption ||
        this.faqDialog.output2.text && this.faqDialog.output2.text.length > this.maxlengthOption
        ) {
        this.titleDialogConfirm = 'Erreur'
        this.contentDialogConfirm = '<p><strong>Un texte que vous voulez enregistrer est trop long.</strong></p><p>Les textes ne peuvent pas dépasser les 512 caractères.<br>Veuillez reduire le nombre de caractères avant de le sauvegarder</p>'
        this.modifications = false
        this.closeDialogUniquement = true
      } else {
        this.titleDialogConfirm = 'Confirmation'
        this.contentDialogConfirm = 'Voulez-vous enregistrer les modifications de cette connaissance ?'
        this.modifications = false
        this.closeDialogUniquement = false
      }
    },
    closeDialogConfirm () {
      this.$emit('submitUpdate', this.ModifFaqDialog)
      this.showDialogConfirmation = false
      // fermer les editeurs de text
      this.modifRep1 = false
      this.modifRep2 = false
    },
    justCloseDialogConfirm () {
      this.showDialogConfirmation = false
    },
    // ouvre dialog modif un exemple
    modifExample (value) {
      console.log('modifExample')
      this.oldExempleSelected = value
      this.exempleSelected = value
      this.showDialogEditExempleIntent = true
    },
    // ferme dialog modif un exemple
    cancelDialogModifExemple () {
      this.showDialogEditExempleIntent = false
    },
    submitExempleIntent (value) {
      this.modifEx(value)
    },
    // modification d'un exemple
    modifEx (data) {
      console.log('modif exemple exempleSelected', this.exempleSelected)
      console.log('modif exemple oldExempleSelected', this.oldExempleSelected)
      // Données modifiées et à renvoyer
      let dataToPost = new window.FormData()
      // il faut retirer le # avant l'enregistrement
      let intentName = this.faqDialog.intend.substring(1, this.faqDialog.intend.length)
      let oldExemple = encodeURIComponent(this.oldExempleSelected)
      dataToPost.append('intent', intentName)
      dataToPost.append('newExemple', this.exempleSelected)
      dataToPost.append('oldExemple', oldExemple)
      dataToPost.append('botWorkspace', this.botWorkspace)
      this.axios.post('https://public.targetfirst.com/public/ibm/update_example_intent.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      // this.axios.post('put/intent.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(response => {
        console.log('modif exemple', response)
        // this.listeQuestion.push(data)
        // console.log('listeQuestion', this.listeQuestion)
        // // il faut aussi mettre a jour le liste des intentions dans le store
        this.MAJIntentsStore(response.data, intentName, 'edit')
        // // this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('Nouvel exemple ajouté'), context: 'success' })
        // // this.showDialogAddQuestionIntent = false
      })
      .catch(_ => {
        // console.log('erreur response', response)
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('erreur d\'enregistrement'), context: 'error' })
      })
      // if (data !== '') this.samplesInt.push(data)
    },

    // ajoute un exemple de question a l'intention
    addExample () {
      this.showDialogAddQuestionIntent = true
      // this.$emit('addExampleIntent')
      console.log('this.faqDialog', this.faqDialog)
      this.intentDialog = {
        botWorkspace: this.botWorkspace,
        code: this.faqDialog.intend,
        desc: this.faqDialog.desc,
        ex: this.listeQuestion,
        response: this.faqDialog.response
      }
    },
    // ajoute un exemple
    addNewEx (data) {
      console.log('ajoute exemple', data)
      this.loadingDialogNew = true
       // Données modifiées et à renvoyer
      let dataToPost = new window.FormData()
      // il faut retirer le # avant l'enregistrement
      let intentName = this.faqDialog.intend.substring(1, this.faqDialog.intend.length)
      dataToPost.append('intent', intentName)
      dataToPost.append('newExemple', data)
      dataToPost.append('botWorkspace', this.botWorkspace)
      this.axios.post('https://public.targetfirst.com/public/ibm/set_new_exemple.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      // this.axios.post('put/intent.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(response => {
        // console.log('nouvel exemple', response)
        console.log('listeQuestion', this.listeQuestion)
        // il faut aussi mettre a jour le liste des intentions dans le store
        this.MAJIntentsStore(response.data, intentName, 'add')
        // this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('Nouvel exemple ajouté'), context: 'success' })
        // this.showDialogAddQuestionIntent = false
      })
      .catch(_ => {
        // console.log('erreur response', response)
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('erreur d\'enregistrement'), context: 'error' })
      })
      // if (data !== '') this.samplesInt.push(data)
    },
    MAJIntentsStore (exemple, intentID, action) {
      console.log('MAJIntentsStore', action)
      let listIntents = _.cloneDeep(this.$store.state._Sites.intents)
      let index = _.findIndex(listIntents, function (o) { return o.code === intentID })
      if (index !== -1) {
        if (action === 'add') {
          // ajoute la nouvelle phrase
          listIntents[index].ex.push(exemple.text)
          this.listeQuestion.push(exemple.text)
        } else if (action === 'edit') {
          // modification de l'exemple'
          // console.log('listIntents[index].ex', listIntents[index].ex)
          let indexModif = listIntents[index].ex.findIndex(ex => ex === this.oldExempleSelected)
          if (indexModif !== -1) {
            console.log('trouvé en ', exemple.text)
            // supprime l'exemple'
            listIntents[index].ex.splice(indexModif, 1, exemple.text)
            this.listeQuestion.splice(indexModif, 1, exemple.text)
          }
        }
        // mise à jour du store
        this.$store.commit('_Sites/SET_INTENTS', listIntents)
        // et mettre à jour la base
        this.MAJExBDD(listIntents[index], action)
      }
    },
    // finir la mise en forme du tableau à envoyer en base
    MAJExBDD (data, action) {
      let newEx = []
      let newObj = {}
      _.forEach(data.ex, function (value) {
        newObj = {text: value}
        newEx.push(newObj)
      })
      console.log(newEx)
      console.log(JSON.stringify(newEx))
      console.log(String(newEx))
      let dataToPost = new window.FormData()
      // il faut retirer le # avant l'enregistrement
      // let intentName = this.faqDialog.intend.substring(1, this.faqDialog.intend.length)
      console.log('data.code', data.code)
      dataToPost.append('intent', data.code)
      dataToPost.append('botWorkspace', this.botWorkspace)
      dataToPost.append('exemples', JSON.stringify(newEx))
      this.axios.post('put/set_exemple_intent.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(response => {
        console.log('MAJExBDD', response)
        if (action === 'add') {
          this.showDialogAddQuestionIntent = false
          this.loadingDialogNew = false
          this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('Nouvel exemple ajouté'), context: 'success' })
        } else if (action === 'edit') {
          this.showDialogEditExempleIntent = false
          this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('Exemple modifié'), context: 'success' })
        }
      })
      .catch(_ => {
        // console.log('erreur response', response)
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('erreur d\'enregistrement'), context: 'error' })
      })
    },
    closeDialogSupExempleIntent () {
      this.showDialogSupExempleIntent = false
    },
    openDialogDeleteExemple (index) {
      this.exempleSup = this.listeQuestion[index]
      this.showDialogSupExempleIntent = true
      console.log('deleteSampleIntent : index', index)
      console.log('deleteSampleIntent : faqDialog', this.faqDialog)
      console.log('listeQuestion', this.listeQuestion)
    },
    closeDialogNewQuestionIntent () {
      this.showDialogAddQuestionIntent = false
    },
    majExempleListe (value) {
      this.listeQuestion = value
      // console.log('majExempleListe', value)
      // console.log('listeQuestion', this.listeQuestion)
    },
    inputEvt (evt, lengthTxt, id) {
      console.log('inputEvt', evt)
      if (evt.length >= lengthTxt) {
        console.log('bloque le clavier', id)
      }
    },
    saveModifBot () {
      this.loadingModifFAQ = true
      console.log('saveModifBot', this.faqDialog)
      // console.log('dif ', this.ModifFaqDialog.desc + ' === ' + this.faqDialog.desc)
      let text1 = ''
      if (this.faqDialog.output1.text) {
        text1 = this.faqDialog.output1.text
        text1 = text1.replaceAll('@', '&#x40;')
      }
      let text2 = ''
      if (this.faqDialog.output2.text) {
        text2 = this.faqDialog.output2.text
        text2 = text2.replaceAll('@', '&#x40;')
      }
      // console.log('this.faqDialog.output2.text', this.faqDialog.output2.text)
      let output = JSON.stringify({
        generic: [
          {
            values: [{text: text1}],
            response_type: 'text',
            selection_policy: 'sequential'
          },
          {
            values: [{text: text2}],
            response_type: 'text',
            selection_policy: 'sequential'
          },
          {
            time: 2000,
            typing: true,
            response_type: 'pause'
          }
        ]
      })

      // Données modifiées et à renvoyer
      let dataToPost = new window.FormData()
      dataToPost.append('dialog_node', this.faqDialog.dialogNode)
      dataToPost.append('title', this.faqDialog.desc)
      dataToPost.append('output', output)
      dataToPost.append('botWorkspace', this.botWorkspace)
      dataToPost.append('next_step', this.faqDialog.nextstep)
      this.axios.post('https://public.targetfirst.com/public/ibm/set_node_base_connaissances.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      // this.axios.post('put/intent.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(response => {
        console.log('response', response)
        this.saveBDD() // enregistre en base
      })
      .catch(_ => {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('erreur intention'), context: 'error' })
      })
      // si la description à changé
      if (this.ModifFaqDialog.desc !== this.faqDialog.desc) {
        let dataToPost = new window.FormData()
        // il faut retirer le # avant l'enregistrement
        let intentName = this.faqDialog.intend.substring(1, this.faqDialog.intend.length)
        dataToPost.append('intent', intentName)
        dataToPost.append('desc', this.faqDialog.desc)
        dataToPost.append('botWorkspace', this.botWorkspace)
        this.axios.post('https://public.targetfirst.com/public/ibm/update_desc_intent.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        // this.axios.post('put/intent.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        .then(response => {
          console.log('update desc response', response)
          // this.saveBDD() // enregistre en base
        })
        .catch(_ => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('erreur intention'), context: 'error' })
        })
      }
    },
    saveBDD () {
      // console.log('saveBDD', this.faqDialog.output1.text.replaceAll('@', '&#x40;'))
      // this.showDialogUpdate = false
      let outputTXT1 = _.clone(this.faqDialog.output1.text)
      let outputTXT2 = _.clone(this.faqDialog.output2.text)
      if (outputTXT1) {
        outputTXT1 = outputTXT1.replaceAll('@', '&#x40;')
        this.faqDialog.output1.text = outputTXT1
      }
      if (outputTXT2) {
        outputTXT2 = outputTXT2.replaceAll('@', '&#x40;')
        this.faqDialog.output2.text = outputTXT2
      }
      // console.log('saveBDD', output1)
      let dataToPost = new window.FormData()
      dataToPost.append('desc', this.faqDialog.desc)
      dataToPost.append('name', this.faqDialog.name)
      dataToPost.append('FAQ_ID', this.faqDialog.id)
      dataToPost.append('output1', JSON.stringify(this.faqDialog.output1))
      dataToPost.append('output2', JSON.stringify(this.faqDialog.output2))
      dataToPost.append('next_step', this.faqDialog.nextstep)
      // this.loadingData = true
      this.axios.post('put/faq.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(response => {
        this.$emit('submitUpdate', this.faqDialog)
        // on clone pour enregister les modifs text pour comparer
        this.ModifFaqDialog = _.cloneDeep(this.faqDialog)
        // this.initBots()
        // Notification
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifSuccess'), context: 'success' })
      })
      .catch(_ => {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifFailure'), context: 'error' })
      })
      .then(_ => {
        this.showDialogConfirmation = false
        // this.loadingData = false
      })
      this.ModifFaqDialog.output1.text = this.faqDialog.output1.text
      this.ModifFaqDialog.output2.text = this.faqDialog.output2.text
      this.loadingModifFAQ = false
      // fermer les editeurs de text
      this.modifRep1 = false
      this.modifRep2 = false
    },
    submitDialogConfirm () {
      this.saveModifBot()
    },
    submitDeleteConfirm () {
      this.loadingModifFAQ = true
      // supprime uniquement 1 faq
      let supFAQ = [{'intent': this.faqDialog.intend, 'id': this.faqDialog.id}]
      let dataToPost = new window.FormData()
      dataToPost.append('sup', JSON.stringify(supFAQ))
      // dataToPost.append('intent', this.faqDialog.intend)
      // dataToPost.append('id', this.faqDialog.id)
      dataToPost.append('botWorkspace', this.botWorkspace)
      // this.loadingData = true
      this.axios.post('https://public.targetfirst.com/public/ibm/delete_faq.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(response => {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifSuccess'), context: 'success' })
        this.showDialogDelete = false
        this.loadingModifFAQ = false
        this.$emit('submitDel', supFAQ)
        // window.location.reload()
        // fermer les editeurs de text
        this.modifRep1 = false
        this.modifRep2 = false
      })
      .catch(_ => {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifFailure'), context: 'error' })
      })
    },
    showImgPrompt (numReponse) {
      alert('affiche input image' + numReponse)
    },
    changeJumpTo () {
      this.checkModifSelect = true
    },
    deleteJumpTo () {
      this.checkModifSelect = true
      this.faqDialog.nextstep = ''
    }
    // changeSection () {
    //   this.currentTab = 0
    // },
    // changeDialogIntent (id) {
    //   this.$emit('changeDialog', id)
    // },
    // // ferme la dialogBox de création de nouvelle intention
    // closeDialogCreatIntent () {
    //   this.showDialogCreateIntent = false
    // }
  },

  watch: {
    intentDialog (val, oldVal) {
      this.originalIntent = ''
      this.intentToCreate = ''
      this.actualIntent = '-'
      this.blockSelector = false
      this.changeIntent = ''
      this.intentDialog.intent ? this.actualIntent = this.intentDialog.intent : this.actualIntent = '-'
      this.originalIntent = this.intentDialog.intent

      if (this.botWorkspace && this.botWorkspace !== 'undefined') {
        this.initList()
      }
      // console.log('this.listIntents', this.listIntents)
      for (let k in this.listIntents) {
        if (this.intentDialog.intent === this.listIntents[k].code) {
          console.log('this.changeIntent', this.changeIntent)
          this.changeIntent = this.listIntents[k]
        }
      }
    },
    intentToCreate (val, oldVal) {
      if (this.intentToCreate === '') {
        this.blockSelector = false
      } else {
        this.blockSelector = true
        this.changeIntent = ''
      }
    },
    showDialogUpdate (val, oldVal) {
      if (this.showDialogUpdate) {
        this.initList()
        // this.afficheReponseBot()
      }
    }
  },

  filters: {
  }
}
</script>

<style scoped>
  .quillWrapper {
    background-color: white;
  }
  .tf_title_dialog {
    text-overflow: ellipsis;
    width: calc(100% - 180px);
    overflow: hidden;
    white-space: nowrap;
  }
  .btnIntentBot {
    cursor: pointer;
  }
  .tf_removeExemple {
    position: absolute;
    right: 0;
    top: 0;
  }
  .tf_modifExemple {
    position: absolute;
    right: 42px;
    top: 0;
  }
  .margRight {
    margin-right: 8px;
  }
  .codeSource {
    background-color: white;
    border: 1px solid #ccc;
  }

</style>



// WEBPACK FOOTER //
// src/components/watcheezy/WzFaq.vue